import React from "react";
import { URLS } from "../../_config";
import { replaceUrlParams, showDate } from "../../_common/functions";
import { Link } from "react-router-dom";

interface RightNewsListProps {
    newsList: any;
    title?: string;
    onLoadMore?: () => void;
    hasMore?: boolean;
    isLoading?: boolean;
    scrollContainerRef?: React.RefObject<HTMLDivElement>;
}

const RightNewsList = ({ newsList, title = '', onLoadMore, hasMore = false, isLoading = false, scrollContainerRef }: RightNewsListProps) => {
    const sentinelRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (!onLoadMore || !sentinelRef.current) return;
        const container = scrollContainerRef?.current ?? null;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting || !hasMore || isLoading) return;
                // Only trigger if the container is actually scrollable (user had to scroll to reach sentinel)
                if (container && container.scrollHeight <= container.clientHeight) return;
                onLoadMore();
            },
            { root: container, rootMargin: '0px', threshold: 0 }
        );
        observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, [onLoadMore, hasMore, isLoading, scrollContainerRef]);

    return (
        <div className="rightnews_list">
            <h4>{title}</h4>
            {
                newsList?.length === 0 && !isLoading && <div className="text-center">No news available</div>
            }
            {
                newsList === null && <div className="text-center my-5">Loading...</div>
            }
            {
                newsList?.map((item: any, index: number) => {
                    return <div key={`newsRight_${index}`} className="right_newslisting" >
                        <Link to={replaceUrlParams(URLS.BLOG_NEWS.NEWS_DETAILS, { slug: item?.slug })} className="right_newsImage">
                            <img src={item?.latest_news_thumb?.original} alt={item?.title} />
                        </Link>
                        <div className="right_newsright">
                            <Link to={replaceUrlParams(URLS.BLOG_NEWS.NEWS_DETAILS, { slug: item?.slug })}>
                                <h5>{item?.title}</h5>
                            </Link>
                            {/* <p>{item?.short_description}</p> */}
                            <div className="d-flex align-items-center justify-content-between  position-absolute bottom-0 start-0 w-100">
                                <div className="news_author">{item?.author_name}</div>
                                <div className="rightnews_date">{showDate(item?.published_date)}</div>
                            </div>
                        </div>
                    </div>
                })
            }
            {isLoading && (
                <div className="text-center my-2">
                    <span className="spinner-border spinner-border-sm" role="status" aria-label="Loading more news" />
                </div>
            )}
            {!hasMore && onLoadMore && newsList?.length > 0 && (
                <div className="text-center text-muted small py-2">You've reached the end</div>
            )}
            <div ref={sentinelRef} />
        </div>
    );
}
export default RightNewsList;
